export default function (totalCharge, quantity, card) {
  fbq("track", "Purchase", {
    value: totalCharge,
    currency: "USD",
    order_id: card.id,
    content_ids: card.id,
    content_type: "product",
  });
  gtag("event", "purchase", {
    allow_custom_scripts: true,
    value: totalCharge,
    transaction_id: card?.id,
    quantity,
    u1: "purchase",
    u2: new Date().toString(),
    u3: charge,
    u4: new Date().toString(),
    u5: card.address_state,
    u6: card.address_zip,
    // 'u7': '[delvmethod]',
    // 'u8': '[confcode]',
    send_to: "DC-2946399/housa717/fevo-0+items_sold",
  });
}
